export default "__VITE_ASSET__B0ntVx9X__"